var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor4New(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3406,
    height: 2369,
    viewBox: "0 0 3406 2369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "4_75",
    d: "M1296.97 895.415L1031.63 1066.84L901.795 873.636L1169.13 696.456L1296.97 895.415Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "4_74",
    d: "M1168.97 696.376L901.151 873.803L775.085 680.208L998.067 532.812L998.868 532.282L998.37 531.459L997.369 529.805L1042.7 500.386L1168.97 696.376Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "4_71",
    d: "M847.716 904.84L579.896 1082.27L452.738 887.507L723.554 712.594L847.716 904.84Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "4_70",
    d: "M707.395 1277.44L580.23 1082.68L848.064 905.103L975.211 1100.02L707.395 1277.44Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "4_69",
    d: "M826.144 1463.81L707.794 1277.79L975.737 1100.37L1095.25 1283.52L826.144 1463.81Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "4_68",
    d: "M1246.97 1483.92L1007.31 1641.6L1003.85 1635.98L1003.31 1635.1L1002.45 1635.67L957.288 1665.61L824.959 1463.05L1095.58 1283.47L1178.87 1409.36L1179.41 1410.17L1180.23 1409.66L1194.04 1401.08L1246.97 1483.92Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "4_67",
    d: "M1330.49 1712.9L1305.81 1728.87L1304.94 1729.43L1305.53 1730.28L1315.94 1745.43L1100.07 1884.3L965.993 1678.77L1206.02 1519.06L1289.17 1645.01L1330.49 1712.9Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "4_76",
    d: "M1551.47 1284.92L1263.15 1472.82L1210.73 1391.01L1228.39 1379.55L1229.23 1379.01L1228.69 1378.17L1176.89 1297.8L1181.54 1294.84L1182.39 1294.3L1181.84 1293.45L1150.39 1245.78L1413.73 1072.36L1551.47 1284.92Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "4_73",
    d: "M997.957 529.161L997.147 529.687L997.644 530.515L998.651 532.192L788.153 670.82L758.197 623.678L757.676 622.857L756.84 623.356L719.165 645.862L589.886 447.789L880.221 258.874L1042.6 500.214L997.957 529.161Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "4_72",
    d: "M679.825 669.367L678.95 669.909L679.517 670.767L711.96 719.924L452.654 887.33L294.377 639.298L589.706 447.383L718.457 645.405L679.825 669.367Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "4_57",
    d: "M2633.35 779.715V890.585H2685.85V1126.71H2350.85V779.715H2633.35Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "4_55",
    d: "M2373.35 1314.71V1367.71H2620V1565.21H2385.35V1628.21H2373.35V1633.71H2141.85V1314.71H2373.35Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "4_58",
    d: "M3148.85 779.715V1025.71H2763.85V963.715H2685.85V890.581H2632.85V779.715H3148.85Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "4_59",
    d: "M3148.85 1025.71V1364.71H2763.85V1025.71H3148.85Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "4_60",
    d: "M3148.85 1364.71V1710.71H2763.85V1364.71H3148.85Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "4_61",
    d: "M2764.09 1618.71V1711.11H3148.85V2048.71H2996.85V1966.81H2871.35V2017.21H2626.85V1618.71H2764.09Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "4_56",
    d: "M2620 1565.71V2017.71H2372.85V1628.06H2385.4V1565.71H2620Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "4_62",
    d: "M2372.85 1696.71V2017.71H2141.35V1696.71H2372.85Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "4_63",
    d: "M2141.85 1696.71V2017.71H1905.85V1696.71H2141.85Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "4_54",
    d: "M2141.85 1314.71V1633.71H1907.85V1314.71H2141.85Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "4_53",
    d: "M1907.85 1314.71V1633.71H1664.85V1559.21H1637.85L1636.85 1314.71H1907.85Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "4_64",
    d: "M1905.85 1696.71V2017.71H1674.85V1696.71H1905.85Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "4_65",
    d: "M1673.85 1696.71V2017.71H1442.85V1696.71H1673.85Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "4_66",
    d: "M1442.85 1696.71V1969.71H1211.42L1143.71 1857.03L1315.4 1745.55L1316.29 1744.97L1315.65 1744.12L1304.79 1729.47L1329.79 1713.12L1379.01 1696.71H1442.85Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor4New);
export default __webpack_public_path__ + "static/media/select_floor_4_new.47ebf63302e6c3a398e16c85350c13ae.svg";
export { ForwardRef as ReactComponent };